/* tslint:disable */
import {
  Patient
} from '../index';

declare var Object: any;
export interface DiagnosisInterface {
  "author"?: string;
  "lastChange"?: Date;
  "text"?: string;
  "id"?: any;
  "patientId"?: any;
  patient?: Patient;
}

export class Diagnosis implements DiagnosisInterface {
  "author": string;
  "lastChange": Date;
  "text": string;
  "id": any;
  "patientId": any;
  patient: Patient;
  constructor(data?: DiagnosisInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Diagnosis`.
   */
  public static getModelName() {
    return "Diagnosis";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Diagnosis for dynamic purposes.
  **/
  public static factory(data: DiagnosisInterface): Diagnosis{
    return new Diagnosis(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Diagnosis',
      plural: 'Diagnoses',
      path: 'Diagnoses',
      idName: 'id',
      properties: {
        "author": {
          name: 'author',
          type: 'string'
        },
        "lastChange": {
          name: 'lastChange',
          type: 'Date'
        },
        "text": {
          name: 'text',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'any'
        },
        "patientId": {
          name: 'patientId',
          type: 'any'
        },
      },
      relations: {
        patient: {
          name: 'patient',
          type: 'Patient',
          model: 'Patient',
          relationType: 'belongsTo',
                  keyFrom: 'patientId',
          keyTo: 'id'
        },
      }
    }
  }
}
